var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'border-b border-gray-500': _vm.popped, '-mt-px': !_vm.popped}},[_c('div',{staticClass:"flex",class:_vm.tabStyle},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }